   import {createRouter,createWebHashHistory} from "vue-router"
   import { isTokenExpired, isRefreshTokenExpired, getToken, clearAllStorage } from '@/utils/tokenUtils'

   const routes=[
    {
        path:'/',
        name:'loginPage',
        component:()=>import(/*webpackChunkName:'loginPage'*/ '@/page/login/loginPage.vue')
    },{
      path:'/loginPage',
      name:'loginPage1',
      component:()=>import(/*webpackChunkName:'loginPage'*/ '@/page/login/loginPage.vue')
  },{
      path:'/appDownload',
      name:'appDownload',
      component:()=>import(/*webpackChunkName:'appDownload'*/ '@/page/app/appDownload.vue'),
      meta: {
        title: "APP下载"
      },
  },{
      path:'/testHansonTable',
      name:'testHansonTable',
      component:()=>import(/*webpackChunkName:'testHansonTable'*/ '@/page/test/testHansonTable.vue') ,
    },{
      path:'/testHansonTable1',
      name:'testHansonTable1',
      component:()=>import(/*webpackChunkName:'testHansonTable1'*/ '@/page/test/testHansonTable1.vue') ,
    },
    {
        path:'/carouselIndex/:refId',
        name:'carouselIndex',
        component:()=>import(/*webpackChunkName:'carouselIndex'*/ '@/page/carousel/carouselIndex.vue'),
        meta: {
          title: "产品展示"
        },
    },{
      path:'/index1Page',
      name:'index1Page',
      component:()=>import(/*webpackChunkName:'index1Page'*/ '@/page/index/index1Page.vue') ,
      redirect:'/deviceInfor_index',
      children:[
        {
          path:'/deviceInfor_index',
          name:'deviceInfor_index',
          component:()=>import(/*webpackChunkName:'deviceInfor_index'*/ '@/page/device/deviceInfor_index.vue'),
          meta: {
            title: "可视化"
          },
        }
      ]
    } ,{
      path:'/index2Page',
      name:'index2Page',
      component:()=>import(/*webpackChunkName:'index2Page'*/ '@/page/index/index2Page.vue') ,
      redirect:'/deviceInfor_index2',
      children:[
        {
          path:'/deviceInfor_index2',
          name:'deviceInfor_index2',
          component:()=>import(/*webpackChunkName:'deviceInfor_index2'*/ '@/page/device/deviceInfor_index2.vue'),
          meta: {
            title: "可视化"
          },
        }
      ]
    }  
    ,{
      path:'/indexTjfxPage',
      name:'indexTjfxPage',
      component:()=>import(/*webpackChunkName:'indexTjfxPage'*/ '@/page/index/indexTjfxPage.vue') ,
      redirect:'/tjfx_map',
      meta: {
        title: "统计分析"
      },
      children:[
        {
          path:'/report_rlbb',
          name:'report_rlbb',
          component:()=>import(/*webpackChunkName:'report_rlbb'*/ '@/page/tjfx/report_rlbb.vue'),
          meta: {
            title: "入料报表"
          },
        },{
          path:'/report_zhbb',
          name:'report_zhbb',
          component:()=>import(/*webpackChunkName:'report_zhbb'*/ '@/page/tjfx/report_zhbb.vue'),
          meta: {
            title: "综合报表"
          },
        },{
          path:'/report_ylbb',
          name:'report_ylbb',
          component:()=>import(/*webpackChunkName:'report_ylbb'*/ '@/page/tjfx/report_ylbb.vue'),
          meta: {
            title: "用料报表"
          },
        },{
          path:'/report_cltj',
          name:'report_cltj',
          component:()=>import(/*webpackChunkName:'report_cltj'*/ '@/page/tjfx/report_cltj.vue'),
          meta: {
            title: "储量统计"
          },
        },{
          path:'/tjfx_map',
          name:'tjfx_map',
          component:()=>import(/*webpackChunkName:'tjfx_map'*/ '@/page/tjfx/tjfx_map.vue'),
          meta: {
            title: "地图分布"
          },
        }
      ]
    } 
    ,{
      path:'/indexQyglPage',
      name:'indexQyglPage',
      component:()=>import(/*webpackChunkName:'indexQyglPage'*/ '@/page/index/indexQyglPage.vue') ,
      redirect:'/companyUser_list',
      meta: {
        title: "企业管理"
      },
      children:[
        {
          path:'/companyUser_list',
          name:'companyUser_list',
          component:()=>import(/*webpackChunkName:'sysRole'*/ '@/page/company/companyUser_list.vue'),
          meta: {
            title: "企业用户"
          },
      },{
        path:'/company_list',
        name:'company_list',
        component:()=>import(/*webpackChunkName:'sysRole'*/ '@/page/company/company_list.vue'),
        meta: {
          title: "企业管理"
        },
    },{
        path:'/company_list_manage',
        name:'company_list_manage',
        component:()=>import(/*webpackChunkName:'sysRole'*/ '@/page/company/company_list_manage.vue'),
        meta: {
          title: "企业用户"
        },
      },
      {
        path:'/companyFin_index',
        name:'companyFin_index',
        component:()=>import(/*webpackChunkName:'companyFin_index'*/ '@/page/fin/companyFin_index.vue'),
        meta: {
          title: "企业财务"
        },
      },
      {
        path:'/companyFin_center',
        name:'companyFin_center',
        component:()=>import(/*webpackChunkName:'companyFin_center'*/ '@/page/fin/companyFin_center.vue'),
        meta: {
          title: "企业财务中心"
        },
      },
      {
        path:'/companyFin_admin_index',
        name:'companyFin_admin_index',
        component:()=>import(/*webpackChunkName:'companyFin_admin_index'*/ '@/page/fin/companyFin_admin_index.vue'),
        meta: {
          title: "企业余额账户管理"
        },
      },
      {
        path:'/companyFin_flowList',
        name:'companyFin_flowList',
        component:()=>import(/*webpackChunkName:'companyFin_flowList'*/ '@/page/fin/companyFin_flowList.vue'),
        meta: {
          title: "余额流水"
        },
      },
      {
        path:'/deviceVersion_list',
        name:'deviceVersion_list',
        component:()=>import(/*webpackChunkName:'sysRole'*/ '@/page/device/deviceVersion_list.vue'),
        meta: {
          title: "升级版本"
        },
      }
      ]
    } 
    ,{
      path:'/indexGzglPage',
      name:'indexGzglPage',
      component:()=>import(/*webpackChunkName:'indexGzglPage'*/ '@/page/index/indexGzglPage.vue') ,
      redirect:'/deviceAfterSalesApply_list',
      meta: {title: "故障管理"},
      children:[
        {
          path:'/deviceAfterSalesApply_list',
          name:'deviceAfterSalesApply_list',
          component:()=>import(/*webpackChunkName:'deviceAfterSalesApply_list'*/ '@/page/device/deviceAfterSalesApply_list.vue'),
          meta: {
            title: "售后申请"
          },
        },
        {
            path:'/appFeedback_list',
            name:'appFeedback_list',
            component:()=>import(/*webpackChunkName:'sysRole'*/ '@/page/app/appFeedback_list.vue'),
            meta: {
              title: "意见反馈"
            },
        },
        {
            path:'/carousel_list',
            name:'carousel_list',
            component:()=>import(/*webpackChunkName:'carousel_list'*/ '@/page/carousel/carousel_list.vue'),
            meta: {
              title: "产品展示"
            },
        }
      ]
    } 
    ,{
      path:'/indexXtszPage',
      name:'indexXtszPage',
      component:()=>import(/*webpackChunkName:'indexXtszPage'*/ '@/page/index/indexXtszPage.vue') ,
      redirect:'/indexXtszPage',
      meta: {title: "系统设置"},
      children:[
         
      ]
    } 
    ,{
      path:'/indexXtglPage',
      name:'indexXtglPage',
      component:()=>import(/*webpackChunkName:'indexXtglPage'*/ '@/page/index/indexXtglPage.vue') ,
      redirect:'/sysUser_list',
      meta: {title: "系统管理"},
      children:[
        {
          path:'/sysUser_list',
          name:'sysUser_list',
          component:()=>import(/*webpackChunkName:'sysMenu'*/ '@/page/sys/sysUser_list.vue'),
          meta: {
            title: "用户管理"
          },
      }, {
        path:'/sysDict_list',
        name:'sysDict_list',
        component:()=>import(/*webpackChunkName:'sysMenu'*/ '@/page/sys/sysDict_list.vue'),
        meta: {
          title: "字典管理"
        },
      }, {
        path:'/sysRules_list',
        name:'sysRules_list',
        component:()=>import(/*webpackChunkName:'sysRules_list'*/ '@/page/sys/sysRules_list.vue'),
        meta: {
          title: "帮助文档管理"
        },
    },
        {
          path:'/sysRole_list',
          name:'sysRole_list',
          component:()=>import(/*webpackChunkName:'sysRole'*/ '@/page/sys/sysRole_list.vue'),
          meta: {
            title: "角色管理"
          },
       }, {
          path:'/sysLog_list',
          name:'sysLog_list',
          component:()=>import(/*webpackChunkName:'sysRole'*/ '@/page/sys/sysLog_list.vue'),
          meta: {
            title: "日志管理"
          },
      },
      {
          path:'/sysDept_list',
          name:'sysDept_list',
          component:()=>import(/*webpackChunkName:'sysRole'*/ '@/page/sys/sysDept_list.vue'),
          meta: {
            title: "部门管理"
          },
      },{
        path:'/product_list',
        name:'product_list',
        component:()=>import(/*webpackChunkName:'product_list'*/ '@/page/device/product_list.vue'),
        meta: {
          title: "产品管理"
        },
      },{
        path:'/oauthClientDetails_list',
        name:'oauthClientDetails_list',
        component:()=>import(/*webpackChunkName:'oauthClientDetails_list'*/ '@/page/sys/oauthClientDetails_list.vue'),
        meta: {
          title: "接口管理"
        },
      },{
        path:'/analysisRules_list/:protocolType',
        name:'analysisRules_list',
        component:()=>import(/*webpackChunkName:'analysisRules_list'*/ '@/page/device/analysisRules_list.vue'),
        meta: {
          title: "解析规则"
        },
      },{
        path:'/analysisParamName_list',
        name:'analysisParamName_list',
        component:()=>import(/*webpackChunkName:'analysisParamName_list'*/ '@/page/device/analysisParamName_list.vue'),
        meta: {
          title: "解析规则名称"
        },
      }
      ,{
        path:'/sysParams_updateMore',
        name:'sysParams_updateMore',
        component:()=>import(/*webpackChunkName:'sysParams_updateMore'*/ '@/page/sys/sysParams_updateMore.vue'),
        meta: {
          title: "其他功能"
        },
      }
      ]
    } 
    ,{
      path:'/indexMsgPage',
      name:'indexMsgPage',
      component:()=>import(/*webpackChunkName:'indexMsgPage'*/ '@/page/index/indexMsgPage.vue') ,
      redirect:'/task_list',
      meta: {title: "消息中心"},
      children:[
        {
          path:'/task_list',
          name:'task_list',
          component:()=>import(/*webpackChunkName:'sysRole'*/ '@/page/task/task_list.vue'),
          meta: {
            title: "消息管理"
          },
        }
        ,{
          path:'/deviceAlarm_list',
          name:'deviceAlarm_list',
          component:()=>import(/*webpackChunkName:'deviceAlarm_list'*/ '@/page/device/deviceAlarm_list.vue'),
          meta: {
            title: "设备报警"
          },
        },{
          path:'/deviceAlarmConfig_list',
          name:'deviceAlarmConfig_list',
          component:()=>import(/*webpackChunkName:'deviceAlarmConfig_list'*/ '@/page/device/deviceAlarmConfig_list.vue'),
          meta: {
            title: "预警规则配置"
          },
        }
      ]
    } 
    ,
    {
      path:'/indexSbglPage',
      name:'indexSbglPage',
      component:()=>import(/*webpackChunkName:'indexSbglPage'*/ '@/page/index/indexSbglPage.vue') ,
      redirect:'/deviceInfor_list_card',
      meta: {
        title: "首页"
      },
      children:[
        {
          path:'/deviceInfor_list_card',
          name:'deviceInfor_list_card',
          component:()=>import(/*webpackChunkName:'product_list'*/ '@/page/device/deviceInfor_list_card.vue'),
          meta: {
            title: "可视化"
          },
        },
      {
        path:'/deviceInfor_list',
        name:'deviceInfor_list',
        component:()=>import(/*webpackChunkName:'deviceInfor_list'*/ '@/page/device/deviceInfor_list.vue'),
        meta: {
          title: "设备列表"
        },
      },
      {
        path:'/deviceInfor_list_batch',
        name:'deviceInfor_list_batch',
        component:()=>import(/*webpackChunkName:'deviceInfor_list_batch'*/ '@/page/device/deviceInfor_list_batch.vue'),
        meta: {
          title: "设备列表(批量设置)"
        },
      },
      {
        path:'/deviceInfor_list_dw',
        name:'deviceInfor_list_dw',
        component:()=>import(/*webpackChunkName:'deviceInfor_list_dw'*/ '@/page/device/deviceInfor_list_dw.vue'),
        meta: {
          title: "设备定位"
        },
      },{
        path:'/deviceInfor_saveMore',
        name:'deviceInfor_saveMore',
        component:()=>import(/*webpackChunkName:'deviceInfor_saveMore'*/ '@/page/device/deviceInfor_saveMore.vue'),
        meta: {
          title: "设备列表"
        },
      },{
        path:'/deviceInfor_real_01',
        name:'deviceInfor_real_01',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_01'*/ '@/page/device/deviceInfor_real_01.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_03',
        name:'deviceInfor_real_03',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_03'*/ '@/page/device/deviceInfor_real_03.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_04',
        name:'deviceInfor_real_04',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_04'*/ '@/page/device/deviceInfor_real_04.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_06',
        name:'deviceInfor_real_06',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_06'*/ '@/page/device/deviceInfor_real_06.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_10',
        name:'deviceInfor_real_10',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_10'*/ '@/page/device/deviceInfor_real_10.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_14',
        name:'deviceInfor_real_14',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_14'*/ '@/page/device/deviceInfor_real_14.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_18',
        name:'deviceInfor_real_18',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_18'*/ '@/page/device/deviceInfor_real_18.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_19',
        name:'deviceInfor_real_19',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_19'*/ '@/page/device/deviceInfor_real_19.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_20',
        name:'deviceInfor_real_20',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_20'*/ '@/page/device/deviceInfor_real_20.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_20y1',
        name:'deviceInfor_real_20y1',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_20y1'*/ '@/page/device/deviceInfor_real_20y1.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_20_v1',
        name:'deviceInfor_real_20_v1',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_20_v1'*/ '@/page/device/deviceInfor_real_20_v1.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_20_v2',
        name:'deviceInfor_real_20_v2',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_20_v2'*/ '@/page/device/deviceInfor_real_20_v2.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_20_xmc',
        name:'deviceInfor_real_20_xmc',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_20_xmc'*/ '@/page/device/deviceInfor_real_20_xmc.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/ranch_weight_visual',
        name:'ranch_weight_visual',
        component:()=>import(/*webpackChunkName:'ranch_weight_visual'*/ '@/page/device/ranch_weight_visual.vue'),
        meta: {
          title: "牛场称重可视化"
        },
      },{
        path:'/deviceInfor_real_21',
        name:'deviceInfor_real_21',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_21'*/ '@/page/device/deviceInfor_real_21.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_22',
        name:'deviceInfor_real_22',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_22'*/ '@/page/device/deviceInfor_real_22.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_27',
        name:'deviceInfor_real_27',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_27'*/ '@/page/device/deviceInfor_real_27.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_24',
        name:'deviceInfor_real_24',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_24'*/ '@/page/device/deviceInfor_real_24.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_26',
        name:'deviceInfor_real_26',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_26'*/ '@/page/device/deviceInfor_real_26.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_28',
        name:'deviceInfor_real_28',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_28'*/ '@/page/device/deviceInfor_real_28.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_29',
        name:'deviceInfor_real_29',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_29'*/ '@/page/device/deviceInfor_real_29.vue'),
        meta: {
          title: "实时数据"
        },
      },{
        path:'/deviceInfor_real_20_lxn',
        name:'deviceInfor_real_20_lxn',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_20_lxn'*/ '@/page/device/deviceInfor_real_20_lxn.vue'),
        meta: {
          title: "实时数据-内料线"
        },
      },{
        path:'/deviceInfor_real_20_lxw',
        name:'deviceInfor_real_20_lxw',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_20_lxw'*/ '@/page/device/deviceInfor_real_20_lxw.vue'),
        meta: {
          title: "实时数据-外料线"
        },
      },{
        path:'/deviceInfor_real_20_lxjz',
        name:'deviceInfor_real_20_lxjz',
        component:()=>import(/*webpackChunkName:'deviceInfor_real_20_lxjz'*/ '@/page/device/deviceInfor_real_20_lxjz.vue'),
        meta: {
          title: "实时数据-集中料线"
        },
      },{
        path:'/deviceOpLog_list',
        name:'deviceOpLog_list',
        component:()=>import(/*webpackChunkName:'deviceOpLog_list'*/ '@/page/device/deviceOpLog_list.vue'),
        meta: {
          title: "操作日志"
        },
      },{
        path:'/deviceConLog_list',
        name:'deviceConLog_list',
        component:()=>import(/*webpackChunkName:'deviceConLog_list'*/ '@/page/device/deviceConLog_list.vue'),
        meta: {
          title: "连接日志"
        },
      },{
        path:'/deviceIps_list',
        name:'deviceIps_list',
        component:()=>import(/*webpackChunkName:'deviceIps_list'*/ '@/page/device/deviceIps_list.vue'),
        meta: {
          title: "IP地址"
        },
      },{
        path:'/devicePutLog_list',
        name:'devicePutLog_list',
        component:()=>import(/*webpackChunkName:'devicePutLog_list'*/ '@/page/device/devicePutLog_list.vue'),
        meta: {
          title: "入料记录"
        },
      },{
        path:'/devicePutLog_list_appeal',
        name:'devicePutLog_list_appeal',
        component:()=>import(/*webpackChunkName:'devicePutLog_list_appeal'*/ '@/page/device/devicePutLog_list_appeal.vue'),
        meta: {
          title: "待处理入料记录"
        },
      }
      ,{
        path:'/devicePutLog_list',
        name:'devicePutLog_list',
        component:()=>import(/*webpackChunkName:'devicePutLog_list'*/ '@/page/device/devicePutLog_list.vue'),
        meta: {
          title: "入库日志"
        },
      },{
        path:'/deviceSimState_list',
        name:'deviceSimState_list',
        component:()=>import(/*webpackChunkName:'deviceSimState_list'*/ '@/page/device/deviceSimState_list.vue'),
        meta: {
          title: "SIM卡状态"
        },
      },{
        path:'/deviceTransfer_list',
        name:'deviceTransfer_list',
        component:()=>import(/*webpackChunkName:'deviceTransfer_list'*/ '@/page/device/deviceTransfer_list.vue'),
        meta: {
          title: "设备转移"
        },
      },{
        path:'/deviceUseLog_list',
        name:'deviceUseLog_list',
        component:()=>import(/*webpackChunkName:'deviceTransfer_list'*/ '@/page/device/deviceUseLog_list.vue'),
        meta: {
          title: "用料统计"
        },
      },{
        path:'/deviceVariable_list',
        name:'deviceVariable_list',
        component:()=>import(/*webpackChunkName:'deviceVariable_list'*/ '@/page/device/deviceVariable_list.vue'),
        meta: {
          title: "变量数据"
        },
      },{
        path:'/deviceAlarmType_list',
        name:'deviceAlarmType_list',
        component:()=>import(/*webpackChunkName:'deviceAlarmType_list'*/ '@/page/device/deviceAlarmType_list.vue'),
        meta: {
          title: "报警类型"
        },
      },{
        path:'/breedRecord_list',
        name:'breedRecord_list',
        component:()=>import(/*webpackChunkName:'breedRecord_list'*/ '@/page/breed/breedRecord_list.vue'),
        meta: {
          title: "养殖管理"
        },
      },{
        path:'/breedRecord_card',
        name:'breedRecord_card',
        component:()=>import(/*webpackChunkName:'breedRecord_card'*/ '@/page/breed/breedRecord_card.vue'),
        meta: {
          title: "可视化"
        },
      },{
        path:'/breedRecord_look/:recordId',
        name:'breedRecord_look',
        component:()=>import(/*webpackChunkName:'breedRecord_look'*/ '@/page/breed/breedRecord_look.vue'),
        meta: {
          title: "可视化"
        },
      }
      ,{
        path:'/breedCheckLog_list',
        name:'breedCheckLog_list',
        component:()=>import(/*webpackChunkName:'breedCheckLog_list'*/ '@/page/breed/breedCheckLog_list.vue'),
        meta: {
          title: "可视化"
        },
      },{
        path:'/breedRecordDay_list',
        name:'breedRecordDay_list',
        component:()=>import(/*webpackChunkName:'breedRebreedRecordDay_listcord_look'*/ '@/page/breed/breedRecordDay_list.vue'),
        meta: {
          title: "可视化"
        },
      },{
        path:'/breedRecordDie_list',
        name:'breedRecordDie_list',
        component:()=>import(/*webpackChunkName:'breedRecordDie_list'*/ '@/page/breed/breedRecordDie_list.vue'),
        meta: {
          title: "可视化"
        },
      },{
        path:'/breedStandard_list',
        name:'breedStandard_list',
        component:()=>import(/*webpackChunkName:'breedStandard_list'*/ '@/page/breed/breedStandard_list.vue'),
        meta: {
          title: "可视化"
        },
      },{
        path:'/breedWeight_list',
        name:'breedWeight_list',
        component:()=>import(/*webpackChunkName:'breedWeight_list'*/ '@/page/breed/breedWeight_list.vue'),
        meta: {
          title: "可视化"
        },
      }
      ]
    }
    ,{
      path:'/cockpitDashboard',
      name:'cockpitDashboard',
      component:()=>import(/*webpackChunkName:'cockpitDashboard'*/ '@/page/cockpit/cockpitDashboard.vue'),
      meta: {
        title: "智能养殖驾驶舱"
      },
    }
    ,{
      path:'/farmMonitor_dashboard',
      name:'farmMonitor_dashboard',
      component:()=>import(/*webpackChunkName:'farmMonitor_dashboard'*/ '@/page/device/farmMonitor_dashboard.vue'),
      meta: {
        title: "养殖场智能监控系统"
      },
    }

   ]

   const router = createRouter({
      // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
      history: createWebHashHistory(),
      linkActiveClass:'active',
      routes, // `routes: routes` 的缩写
   })
 
   /**
    * 路由前置守卫
    * 1. 检查是否有token
    * 2. 检查token和refresh token是否过期
    * 3. 如果都过期，清除本地存储并跳转登录
    */
   router.beforeEach(async (to, from) => {
     // 白名单：不需要token的
     const whiteList = ['loginPage', 'loginPage1', 'carouselIndex', 'farmMonitor_dashboard', 'appDownload'];
     
     // 如果是白名单页面，直接放行
     if (whiteList.includes(to.name)) {
       return true;
     }
     
     // 检查是否有token
     let token = getToken();
     
     if (!token) {
       // 没有token，跳转登录
       console.log('未登录，跳转登录页');
       return { name: 'loginPage' };
     }
     
     // 检查token和refresh token是否都已过期
     if (isTokenExpired() && isRefreshTokenExpired()) {
       // 两个token都过期了，清除本地存储并跳转登录
       console.log('Token和Refresh Token都已过期，跳转登录页');
       clearAllStorage();
       return { name: 'loginPage' };
     }
     
     // token存在且至少有一个未过期，放行
     // 具体的刷新逻辑由axios拦截器处理
     return true;
   })

 
  export default router

